/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: string; output: string; }
  BigInt: { input: string; output: string; }
  Bytes: { input: string; output: string; }
  /**
   * 8 bytes signed integer
   *
   */
  Int8: { input: number; output: number; }
  /**
   * A string representation of microseconds UNIX timestamp (16 digits)
   *
   */
  Timestamp: { input: number; output: number; }
};

export enum AggregationInterval {
  Day = 'day',
  Hour = 'hour'
}

export type Asset = {
  __typename?: 'Asset';
  address: Scalars['String']['output'];
  assetType: AssetType;
  decimals?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kya?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  tokenId?: Maybe<Scalars['Int']['output']>;
  tokenStandard: TokenStandard;
  tradedVolume: Scalars['BigDecimal']['output'];
};

export type AssetPrice = {
  __typename?: 'AssetPrice';
  asset: Asset;
  id: Scalars['ID']['output'];
  offerMaximumPrice?: Maybe<Scalars['BigDecimal']['output']>;
  offerMinimumPrice?: Maybe<Scalars['BigDecimal']['output']>;
  priceFeedAddress?: Maybe<Scalars['String']['output']>;
};

export type AssetPriceFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<AssetPriceFilter>>>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<AssetFilter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  offerMaximumPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMaximumPrice_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMaximumPrice_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMaximumPrice_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  offerMaximumPrice_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMaximumPrice_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMaximumPrice_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMaximumPrice_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  offerMinimumPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMinimumPrice_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMinimumPrice_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMinimumPrice_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  offerMinimumPrice_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMinimumPrice_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMinimumPrice_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  offerMinimumPrice_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  or?: InputMaybe<Array<InputMaybe<AssetPriceFilter>>>;
  priceFeedAddress?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_contains?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_ends_with?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_gt?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_gte?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  priceFeedAddress_lt?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_lte?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_not?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  priceFeedAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_starts_with?: InputMaybe<Scalars['String']['input']>;
  priceFeedAddress_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum AssetPriceOrderBy {
  Asset = 'asset',
  AssetAddress = 'asset__address',
  AssetAssetType = 'asset__assetType',
  AssetDecimals = 'asset__decimals',
  AssetId = 'asset__id',
  AssetKya = 'asset__kya',
  AssetName = 'asset__name',
  AssetSymbol = 'asset__symbol',
  AssetTokenId = 'asset__tokenId',
  AssetTokenStandard = 'asset__tokenStandard',
  AssetTradedVolume = 'asset__tradedVolume',
  Id = 'id',
  OfferMaximumPrice = 'offerMaximumPrice',
  OfferMinimumPrice = 'offerMinimumPrice',
  PriceFeedAddress = 'priceFeedAddress'
}

export enum AssetType {
  Gold = 'Gold',
  NoType = 'NoType',
  Security = 'Security'
}

export type AssetFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  address?: InputMaybe<Scalars['String']['input']>;
  address_contains?: InputMaybe<Scalars['String']['input']>;
  address_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  address_ends_with?: InputMaybe<Scalars['String']['input']>;
  address_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  address_gt?: InputMaybe<Scalars['String']['input']>;
  address_gte?: InputMaybe<Scalars['String']['input']>;
  address_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_lt?: InputMaybe<Scalars['String']['input']>;
  address_lte?: InputMaybe<Scalars['String']['input']>;
  address_not?: InputMaybe<Scalars['String']['input']>;
  address_not_contains?: InputMaybe<Scalars['String']['input']>;
  address_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  address_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  address_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  address_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  address_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  address_starts_with?: InputMaybe<Scalars['String']['input']>;
  address_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  assetType?: InputMaybe<AssetType>;
  assetType_in?: InputMaybe<Array<AssetType>>;
  assetType_not?: InputMaybe<AssetType>;
  assetType_not_in?: InputMaybe<Array<AssetType>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  kya?: InputMaybe<Scalars['String']['input']>;
  kya_contains?: InputMaybe<Scalars['String']['input']>;
  kya_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_ends_with?: InputMaybe<Scalars['String']['input']>;
  kya_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_gt?: InputMaybe<Scalars['String']['input']>;
  kya_gte?: InputMaybe<Scalars['String']['input']>;
  kya_in?: InputMaybe<Array<Scalars['String']['input']>>;
  kya_lt?: InputMaybe<Scalars['String']['input']>;
  kya_lte?: InputMaybe<Scalars['String']['input']>;
  kya_not?: InputMaybe<Scalars['String']['input']>;
  kya_not_contains?: InputMaybe<Scalars['String']['input']>;
  kya_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  kya_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  kya_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  kya_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_starts_with?: InputMaybe<Scalars['String']['input']>;
  kya_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId?: InputMaybe<Scalars['Int']['input']>;
  tokenId_gt?: InputMaybe<Scalars['Int']['input']>;
  tokenId_gte?: InputMaybe<Scalars['Int']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['Int']['input']>;
  tokenId_lte?: InputMaybe<Scalars['Int']['input']>;
  tokenId_not?: InputMaybe<Scalars['Int']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tokenStandard?: InputMaybe<TokenStandard>;
  tokenStandard_in?: InputMaybe<Array<TokenStandard>>;
  tokenStandard_not?: InputMaybe<TokenStandard>;
  tokenStandard_not_in?: InputMaybe<Array<TokenStandard>>;
  tradedVolume?: InputMaybe<Scalars['BigDecimal']['input']>;
  tradedVolume_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tradedVolume_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tradedVolume_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tradedVolume_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tradedVolume_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tradedVolume_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tradedVolume_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum AssetOrderBy {
  Address = 'address',
  AssetType = 'assetType',
  Decimals = 'decimals',
  Id = 'id',
  Kya = 'kya',
  Name = 'name',
  Symbol = 'symbol',
  TokenId = 'tokenId',
  TokenStandard = 'tokenStandard',
  TradedVolume = 'tradedVolume'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type BlockHeight = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type Offer = {
  __typename?: 'Offer';
  amountIn: Scalars['BigDecimal']['output'];
  amountOut?: Maybe<Scalars['BigDecimal']['output']>;
  authorizationAddresses?: Maybe<Array<Scalars['String']['output']>>;
  availableAmount: Scalars['BigDecimal']['output'];
  cancelledAt?: Maybe<Scalars['BigInt']['output']>;
  commsLink?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['BigInt']['output'];
  createdAtTxHash: Scalars['String']['output'];
  depositAsset: Asset;
  expiryTimestamp: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  isAuth: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  maker: Scalars['String']['output'];
  offerPrice: OfferPrice;
  offerStatus: OfferStatus;
  offerType: OfferType;
  orders: Array<Order>;
  specialAddresses?: Maybe<Array<Scalars['String']['output']>>;
  terms?: Maybe<Scalars['String']['output']>;
  timelockPeriod: Scalars['BigInt']['output'];
  withdrawalAsset: Asset;
};


export type OfferOrdersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderFilter>;
};

export type OfferPrice = {
  __typename?: 'OfferPrice';
  Offer: Offer;
  depositAssetPrice?: Maybe<AssetPrice>;
  id: Scalars['ID']['output'];
  percentage?: Maybe<Scalars['Int']['output']>;
  percentageType?: Maybe<PercentageType>;
  pricingType: OfferPricingType;
  unitPrice?: Maybe<Scalars['BigDecimal']['output']>;
  withdrawalAssetPrice?: Maybe<AssetPrice>;
};

export type OfferPriceFilter = {
  Offer?: InputMaybe<Scalars['String']['input']>;
  Offer_?: InputMaybe<OfferFilter>;
  Offer_contains?: InputMaybe<Scalars['String']['input']>;
  Offer_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_ends_with?: InputMaybe<Scalars['String']['input']>;
  Offer_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_gt?: InputMaybe<Scalars['String']['input']>;
  Offer_gte?: InputMaybe<Scalars['String']['input']>;
  Offer_in?: InputMaybe<Array<Scalars['String']['input']>>;
  Offer_lt?: InputMaybe<Scalars['String']['input']>;
  Offer_lte?: InputMaybe<Scalars['String']['input']>;
  Offer_not?: InputMaybe<Scalars['String']['input']>;
  Offer_not_contains?: InputMaybe<Scalars['String']['input']>;
  Offer_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  Offer_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  Offer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  Offer_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_starts_with?: InputMaybe<Scalars['String']['input']>;
  Offer_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OfferPriceFilter>>>;
  depositAssetPrice?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_?: InputMaybe<AssetPriceFilter>;
  depositAssetPrice_contains?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_ends_with?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_gt?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_gte?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_in?: InputMaybe<Array<Scalars['String']['input']>>;
  depositAssetPrice_lt?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_lte?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_not?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_not_contains?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  depositAssetPrice_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_starts_with?: InputMaybe<Scalars['String']['input']>;
  depositAssetPrice_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<OfferPriceFilter>>>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  percentageType?: InputMaybe<PercentageType>;
  percentageType_in?: InputMaybe<Array<PercentageType>>;
  percentageType_not?: InputMaybe<PercentageType>;
  percentageType_not_in?: InputMaybe<Array<PercentageType>>;
  percentage_gt?: InputMaybe<Scalars['Int']['input']>;
  percentage_gte?: InputMaybe<Scalars['Int']['input']>;
  percentage_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  percentage_lt?: InputMaybe<Scalars['Int']['input']>;
  percentage_lte?: InputMaybe<Scalars['Int']['input']>;
  percentage_not?: InputMaybe<Scalars['Int']['input']>;
  percentage_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  pricingType?: InputMaybe<OfferPricingType>;
  pricingType_in?: InputMaybe<Array<OfferPricingType>>;
  pricingType_not?: InputMaybe<OfferPricingType>;
  pricingType_not_in?: InputMaybe<Array<OfferPricingType>>;
  unitPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  unitPrice_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  unitPrice_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  unitPrice_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  unitPrice_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  unitPrice_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  unitPrice_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  unitPrice_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  withdrawalAssetPrice?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_?: InputMaybe<AssetPriceFilter>;
  withdrawalAssetPrice_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_gt?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_gte?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalAssetPrice_lt?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_lte?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_not?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_not_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalAssetPrice_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAssetPrice_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OfferPriceOrderBy {
  Offer = 'Offer',
  OfferAmountIn = 'Offer__amountIn',
  OfferAmountOut = 'Offer__amountOut',
  OfferAvailableAmount = 'Offer__availableAmount',
  OfferCancelledAt = 'Offer__cancelledAt',
  OfferCommsLink = 'Offer__commsLink',
  OfferCreatedAt = 'Offer__createdAt',
  OfferCreatedAtTxHash = 'Offer__createdAtTxHash',
  OfferExpiryTimestamp = 'Offer__expiryTimestamp',
  OfferId = 'Offer__id',
  OfferIsAuth = 'Offer__isAuth',
  OfferIsPrivate = 'Offer__isPrivate',
  OfferMaker = 'Offer__maker',
  OfferOfferStatus = 'Offer__offerStatus',
  OfferOfferType = 'Offer__offerType',
  OfferTerms = 'Offer__terms',
  OfferTimelockPeriod = 'Offer__timelockPeriod',
  DepositAssetPrice = 'depositAssetPrice',
  DepositAssetPriceId = 'depositAssetPrice__id',
  DepositAssetPriceOfferMaximumPrice = 'depositAssetPrice__offerMaximumPrice',
  DepositAssetPriceOfferMinimumPrice = 'depositAssetPrice__offerMinimumPrice',
  DepositAssetPricePriceFeedAddress = 'depositAssetPrice__priceFeedAddress',
  Id = 'id',
  Percentage = 'percentage',
  PercentageType = 'percentageType',
  PricingType = 'pricingType',
  UnitPrice = 'unitPrice',
  WithdrawalAssetPrice = 'withdrawalAssetPrice',
  WithdrawalAssetPriceId = 'withdrawalAssetPrice__id',
  WithdrawalAssetPriceOfferMaximumPrice = 'withdrawalAssetPrice__offerMaximumPrice',
  WithdrawalAssetPriceOfferMinimumPrice = 'withdrawalAssetPrice__offerMinimumPrice',
  WithdrawalAssetPricePriceFeedAddress = 'withdrawalAssetPrice__priceFeedAddress'
}

export enum OfferPricingType {
  DynamicPricing = 'DynamicPricing',
  FixedPricing = 'FixedPricing',
  NoType = 'NoType'
}

export enum OfferStatus {
  Cancelled = 'Cancelled',
  FullyTaken = 'FullyTaken',
  NotTaken = 'NotTaken',
  PartiallyTaken = 'PartiallyTaken'
}

export enum OfferType {
  BlockOffer = 'BlockOffer',
  NoType = 'NoType',
  PartialOffer = 'PartialOffer'
}

export type OfferFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountIn?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountIn_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountOut?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountOut_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<OfferFilter>>>;
  authorizationAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationAddresses_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationAddresses_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationAddresses_not?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationAddresses_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationAddresses_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  availableAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  availableAmount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  cancelledAt?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cancelledAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  commsLink?: InputMaybe<Scalars['String']['input']>;
  commsLink_contains?: InputMaybe<Scalars['String']['input']>;
  commsLink_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  commsLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  commsLink_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  commsLink_gt?: InputMaybe<Scalars['String']['input']>;
  commsLink_gte?: InputMaybe<Scalars['String']['input']>;
  commsLink_in?: InputMaybe<Array<Scalars['String']['input']>>;
  commsLink_lt?: InputMaybe<Scalars['String']['input']>;
  commsLink_lte?: InputMaybe<Scalars['String']['input']>;
  commsLink_not?: InputMaybe<Scalars['String']['input']>;
  commsLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  commsLink_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  commsLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  commsLink_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  commsLink_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  commsLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  commsLink_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  commsLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  commsLink_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAtTxHash?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_contains?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_gt?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_gte?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAtTxHash_lt?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_lte?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_not?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAtTxHash_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAtTxHash_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositAsset?: InputMaybe<Scalars['String']['input']>;
  depositAsset_?: InputMaybe<AssetFilter>;
  depositAsset_contains?: InputMaybe<Scalars['String']['input']>;
  depositAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  depositAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_gt?: InputMaybe<Scalars['String']['input']>;
  depositAsset_gte?: InputMaybe<Scalars['String']['input']>;
  depositAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  depositAsset_lt?: InputMaybe<Scalars['String']['input']>;
  depositAsset_lte?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  depositAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  depositAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  expiryTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expiryTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isAuth?: InputMaybe<Scalars['Boolean']['input']>;
  isAuth_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isAuth_not?: InputMaybe<Scalars['Boolean']['input']>;
  isAuth_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPrivate_not?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  maker?: InputMaybe<Scalars['String']['input']>;
  maker_contains?: InputMaybe<Scalars['String']['input']>;
  maker_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  maker_ends_with?: InputMaybe<Scalars['String']['input']>;
  maker_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  maker_gt?: InputMaybe<Scalars['String']['input']>;
  maker_gte?: InputMaybe<Scalars['String']['input']>;
  maker_in?: InputMaybe<Array<Scalars['String']['input']>>;
  maker_lt?: InputMaybe<Scalars['String']['input']>;
  maker_lte?: InputMaybe<Scalars['String']['input']>;
  maker_not?: InputMaybe<Scalars['String']['input']>;
  maker_not_contains?: InputMaybe<Scalars['String']['input']>;
  maker_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  maker_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  maker_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  maker_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  maker_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  maker_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  maker_starts_with?: InputMaybe<Scalars['String']['input']>;
  maker_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  offerPrice_?: InputMaybe<OfferPriceFilter>;
  offerStatus?: InputMaybe<OfferStatus>;
  offerStatus_in?: InputMaybe<Array<OfferStatus>>;
  offerStatus_not?: InputMaybe<OfferStatus>;
  offerStatus_not_in?: InputMaybe<Array<OfferStatus>>;
  offerType?: InputMaybe<OfferType>;
  offerType_in?: InputMaybe<Array<OfferType>>;
  offerType_not?: InputMaybe<OfferType>;
  offerType_not_in?: InputMaybe<Array<OfferType>>;
  or?: InputMaybe<Array<InputMaybe<OfferFilter>>>;
  orders_?: InputMaybe<OrderFilter>;
  specialAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  specialAddresses_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  specialAddresses_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  specialAddresses_not?: InputMaybe<Array<Scalars['String']['input']>>;
  specialAddresses_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  specialAddresses_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  terms?: InputMaybe<Scalars['String']['input']>;
  terms_contains?: InputMaybe<Scalars['String']['input']>;
  terms_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  terms_ends_with?: InputMaybe<Scalars['String']['input']>;
  terms_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  terms_gt?: InputMaybe<Scalars['String']['input']>;
  terms_gte?: InputMaybe<Scalars['String']['input']>;
  terms_in?: InputMaybe<Array<Scalars['String']['input']>>;
  terms_lt?: InputMaybe<Scalars['String']['input']>;
  terms_lte?: InputMaybe<Scalars['String']['input']>;
  terms_not?: InputMaybe<Scalars['String']['input']>;
  terms_not_contains?: InputMaybe<Scalars['String']['input']>;
  terms_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  terms_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  terms_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  terms_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  terms_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  terms_starts_with?: InputMaybe<Scalars['String']['input']>;
  terms_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timelockPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timelockPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawalAsset?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_?: InputMaybe<AssetFilter>;
  withdrawalAsset_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_gt?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_gte?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalAsset_lt?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_lte?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OfferOrderBy {
  AmountIn = 'amountIn',
  AmountOut = 'amountOut',
  AuthorizationAddresses = 'authorizationAddresses',
  AvailableAmount = 'availableAmount',
  CancelledAt = 'cancelledAt',
  CommsLink = 'commsLink',
  CreatedAt = 'createdAt',
  CreatedAtTxHash = 'createdAtTxHash',
  DepositAsset = 'depositAsset',
  DepositAssetAddress = 'depositAsset__address',
  DepositAssetAssetType = 'depositAsset__assetType',
  DepositAssetDecimals = 'depositAsset__decimals',
  DepositAssetId = 'depositAsset__id',
  DepositAssetKya = 'depositAsset__kya',
  DepositAssetName = 'depositAsset__name',
  DepositAssetSymbol = 'depositAsset__symbol',
  DepositAssetTokenId = 'depositAsset__tokenId',
  DepositAssetTokenStandard = 'depositAsset__tokenStandard',
  DepositAssetTradedVolume = 'depositAsset__tradedVolume',
  ExpiryTimestamp = 'expiryTimestamp',
  Id = 'id',
  IsAuth = 'isAuth',
  IsPrivate = 'isPrivate',
  Maker = 'maker',
  OfferPrice = 'offerPrice',
  OfferPriceId = 'offerPrice__id',
  OfferPricePercentage = 'offerPrice__percentage',
  OfferPricePercentageType = 'offerPrice__percentageType',
  OfferPricePricingType = 'offerPrice__pricingType',
  OfferPriceUnitPrice = 'offerPrice__unitPrice',
  OfferStatus = 'offerStatus',
  OfferType = 'offerType',
  Orders = 'orders',
  SpecialAddresses = 'specialAddresses',
  Terms = 'terms',
  TimelockPeriod = 'timelockPeriod',
  WithdrawalAsset = 'withdrawalAsset',
  WithdrawalAssetAddress = 'withdrawalAsset__address',
  WithdrawalAssetAssetType = 'withdrawalAsset__assetType',
  WithdrawalAssetDecimals = 'withdrawalAsset__decimals',
  WithdrawalAssetId = 'withdrawalAsset__id',
  WithdrawalAssetKya = 'withdrawalAsset__kya',
  WithdrawalAssetName = 'withdrawalAsset__name',
  WithdrawalAssetSymbol = 'withdrawalAsset__symbol',
  WithdrawalAssetTokenId = 'withdrawalAsset__tokenId',
  WithdrawalAssetTokenStandard = 'withdrawalAsset__tokenStandard',
  WithdrawalAssetTradedVolume = 'withdrawalAsset__tradedVolume'
}

export type Order = {
  __typename?: 'Order';
  Offer: Offer;
  affiliate?: Maybe<Scalars['String']['output']>;
  amountPaid: Scalars['BigDecimal']['output'];
  amountToReceive: Scalars['BigDecimal']['output'];
  createdAt: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  isTakerAffiliate?: Maybe<Scalars['Boolean']['output']>;
  orderedBy: Scalars['Bytes']['output'];
};

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderFilter = {
  Offer?: InputMaybe<Scalars['String']['input']>;
  Offer_?: InputMaybe<OfferFilter>;
  Offer_contains?: InputMaybe<Scalars['String']['input']>;
  Offer_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_ends_with?: InputMaybe<Scalars['String']['input']>;
  Offer_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_gt?: InputMaybe<Scalars['String']['input']>;
  Offer_gte?: InputMaybe<Scalars['String']['input']>;
  Offer_in?: InputMaybe<Array<Scalars['String']['input']>>;
  Offer_lt?: InputMaybe<Scalars['String']['input']>;
  Offer_lte?: InputMaybe<Scalars['String']['input']>;
  Offer_not?: InputMaybe<Scalars['String']['input']>;
  Offer_not_contains?: InputMaybe<Scalars['String']['input']>;
  Offer_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  Offer_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  Offer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  Offer_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  Offer_starts_with?: InputMaybe<Scalars['String']['input']>;
  Offer_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  affiliate?: InputMaybe<Scalars['String']['input']>;
  affiliate_contains?: InputMaybe<Scalars['String']['input']>;
  affiliate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  affiliate_ends_with?: InputMaybe<Scalars['String']['input']>;
  affiliate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  affiliate_gt?: InputMaybe<Scalars['String']['input']>;
  affiliate_gte?: InputMaybe<Scalars['String']['input']>;
  affiliate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  affiliate_lt?: InputMaybe<Scalars['String']['input']>;
  affiliate_lte?: InputMaybe<Scalars['String']['input']>;
  affiliate_not?: InputMaybe<Scalars['String']['input']>;
  affiliate_not_contains?: InputMaybe<Scalars['String']['input']>;
  affiliate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  affiliate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  affiliate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  affiliate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  affiliate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  affiliate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  affiliate_starts_with?: InputMaybe<Scalars['String']['input']>;
  affiliate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  amountPaid?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountPaid_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountToReceive?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountToReceive_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<OrderFilter>>>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isTakerAffiliate?: InputMaybe<Scalars['Boolean']['input']>;
  isTakerAffiliate_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isTakerAffiliate_not?: InputMaybe<Scalars['Boolean']['input']>;
  isTakerAffiliate_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  or?: InputMaybe<Array<InputMaybe<OrderFilter>>>;
  orderedBy?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_contains?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_gt?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_gte?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  orderedBy_lt?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_lte?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_not?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum OrderOrderBy {
  Offer = 'Offer',
  OfferAmountIn = 'Offer__amountIn',
  OfferAmountOut = 'Offer__amountOut',
  OfferAvailableAmount = 'Offer__availableAmount',
  OfferCancelledAt = 'Offer__cancelledAt',
  OfferCommsLink = 'Offer__commsLink',
  OfferCreatedAt = 'Offer__createdAt',
  OfferCreatedAtTxHash = 'Offer__createdAtTxHash',
  OfferExpiryTimestamp = 'Offer__expiryTimestamp',
  OfferId = 'Offer__id',
  OfferIsAuth = 'Offer__isAuth',
  OfferIsPrivate = 'Offer__isPrivate',
  OfferMaker = 'Offer__maker',
  OfferOfferStatus = 'Offer__offerStatus',
  OfferOfferType = 'Offer__offerType',
  OfferTerms = 'Offer__terms',
  OfferTimelockPeriod = 'Offer__timelockPeriod',
  Affiliate = 'affiliate',
  AmountPaid = 'amountPaid',
  AmountToReceive = 'amountToReceive',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsTakerAffiliate = 'isTakerAffiliate',
  OrderedBy = 'orderedBy'
}

export enum PercentageType {
  Minus = 'Minus',
  NoType = 'NoType',
  Plus = 'Plus'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<Meta>;
  asset?: Maybe<Asset>;
  assetPrice?: Maybe<AssetPrice>;
  assetPrices: Array<AssetPrice>;
  assets: Array<Asset>;
  offer?: Maybe<Offer>;
  offerPrice?: Maybe<OfferPrice>;
  offerPrices: Array<OfferPrice>;
  offers: Array<Offer>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  securities: Array<Security>;
  security?: Maybe<Security>;
  securityFactories: Array<SecurityFactory>;
  securityFactory?: Maybe<SecurityFactory>;
  securityMetadata?: Maybe<SecurityMetadata>;
  securityMetadata_collection: Array<SecurityMetadata>;
  sx1155?: Maybe<Sx1155>;
  sx1155S: Array<Sx1155>;
  transaction?: Maybe<Transaction>;
  transactions: Array<Transaction>;
  user?: Maybe<User>;
  users: Array<User>;
};


export type QueryMetaArgs = {
  block?: InputMaybe<BlockHeight>;
};


export type QueryAssetArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryAssetPriceArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryAssetPricesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetPriceOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetPriceFilter>;
};


export type QueryAssetsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetFilter>;
};


export type QueryOfferArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryOfferPriceArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryOfferPricesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfferPriceOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OfferPriceFilter>;
};


export type QueryOffersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfferOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OfferFilter>;
};


export type QueryOrderArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryOrdersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OrderFilter>;
};


export type QuerySecuritiesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SecurityFilter>;
};


export type QuerySecurityArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QuerySecurityFactoriesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityFactoryOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SecurityFactoryFilter>;
};


export type QuerySecurityFactoryArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QuerySecurityMetadataArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QuerySecurityMetadataCollectionArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityMetadataOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SecurityMetadataFilter>;
};


export type QuerySx1155Args = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QuerySx1155SArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Sx1155OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<Sx1155Filter>;
};


export type QueryTransactionArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryTransactionsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<TransactionFilter>;
};


export type QueryUserArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryUsersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<UserFilter>;
};

export type Sx1155 = {
  __typename?: 'SX1155';
  /** SX1155 asset */
  assets: Array<Asset>;
  /** SX1155 address */
  id: Scalars['ID']['output'];
};


export type Sx1155AssetsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetFilter>;
};

export type Sx1155Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Sx1155Filter>>>;
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
  assets_?: InputMaybe<AssetFilter>;
  assets_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  assets_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  assets_not?: InputMaybe<Array<Scalars['String']['input']>>;
  assets_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  assets_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Sx1155Filter>>>;
};

export enum Sx1155OrderBy {
  Assets = 'assets',
  Id = 'id'
}

export type Security = {
  __typename?: 'Security';
  /** Agents */
  agents: Array<Scalars['String']['output']>;
  /** Asset entity */
  asset: Asset;
  /** Auth contracts */
  authorizationList: Array<Scalars['String']['output']>;
  /** Value from AssetTokenFactory state */
  enabled: Scalars['Boolean']['output'];
  /** Factory that was used to deploy */
  factory: SecurityFactory;
  frozen: Scalars['Boolean']['output'];
  /** Asset's address */
  id: Scalars['ID']['output'];
  /** Know Your Asset */
  kya?: Maybe<Scalars['String']['output']>;
  /** The value is in percent per seconds, 20 digits */
  lastInterestRate: Scalars['BigInt']['output'];
  /** Data from the ipfs path specified in kya property */
  metadata?: Maybe<SecurityMetadata>;
  /** minimum Redemption Amount (in Asset token value) */
  minimumRedemptionAmount: Scalars['BigDecimal']['output'];
  /** if this gets overgrown the contract change state, [0.01 - 1] */
  statePercent: Scalars['BigDecimal']['output'];
};

export type SecurityFactory = {
  __typename?: 'SecurityFactory';
  /** The address of SecurityFactory contract */
  id: Scalars['ID']['output'];
  /** All AssetTokens deployed with this factory */
  securities?: Maybe<Array<Security>>;
  /** Number of securities that were deployed by this factory */
  securitiesCount: Scalars['Int']['output'];
};


export type SecurityFactorySecuritiesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SecurityFilter>;
};

export type SecurityFactoryFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SecurityFactoryFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SecurityFactoryFilter>>>;
  securitiesCount?: InputMaybe<Scalars['Int']['input']>;
  securitiesCount_gt?: InputMaybe<Scalars['Int']['input']>;
  securitiesCount_gte?: InputMaybe<Scalars['Int']['input']>;
  securitiesCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  securitiesCount_lt?: InputMaybe<Scalars['Int']['input']>;
  securitiesCount_lte?: InputMaybe<Scalars['Int']['input']>;
  securitiesCount_not?: InputMaybe<Scalars['Int']['input']>;
  securitiesCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  securities_?: InputMaybe<SecurityFilter>;
};

export enum SecurityFactoryOrderBy {
  Id = 'id',
  Securities = 'securities',
  SecuritiesCount = 'securitiesCount'
}

export type SecurityMetadata = {
  __typename?: 'SecurityMetadata';
  description?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** IPFS hash or path to the json file on ipfs */
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  /** Security */
  security?: Maybe<Security>;
  securityType: SecurityType;
};

export type SecurityMetadataFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SecurityMetadataFilter>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_gt?: InputMaybe<Scalars['String']['input']>;
  externalUrl_gte?: InputMaybe<Scalars['String']['input']>;
  externalUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  externalUrl_lt?: InputMaybe<Scalars['String']['input']>;
  externalUrl_lte?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  externalUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_contains?: InputMaybe<Scalars['String']['input']>;
  image_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  image_ends_with?: InputMaybe<Scalars['String']['input']>;
  image_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  image_gt?: InputMaybe<Scalars['String']['input']>;
  image_gte?: InputMaybe<Scalars['String']['input']>;
  image_in?: InputMaybe<Array<Scalars['String']['input']>>;
  image_lt?: InputMaybe<Scalars['String']['input']>;
  image_lte?: InputMaybe<Scalars['String']['input']>;
  image_not?: InputMaybe<Scalars['String']['input']>;
  image_not_contains?: InputMaybe<Scalars['String']['input']>;
  image_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  image_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  image_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  image_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  image_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  image_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  image_starts_with?: InputMaybe<Scalars['String']['input']>;
  image_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<SecurityMetadataFilter>>>;
  securityType?: InputMaybe<SecurityType>;
  securityType_in?: InputMaybe<Array<SecurityType>>;
  securityType_not?: InputMaybe<SecurityType>;
  securityType_not_in?: InputMaybe<Array<SecurityType>>;
  security_?: InputMaybe<SecurityFilter>;
};

export enum SecurityMetadataOrderBy {
  Description = 'description',
  ExternalUrl = 'externalUrl',
  Id = 'id',
  Image = 'image',
  Security = 'security',
  SecurityType = 'securityType',
  SecurityEnabled = 'security__enabled',
  SecurityFrozen = 'security__frozen',
  SecurityId = 'security__id',
  SecurityKya = 'security__kya',
  SecurityLastInterestRate = 'security__lastInterestRate',
  SecurityMinimumRedemptionAmount = 'security__minimumRedemptionAmount',
  SecurityStatePercent = 'security__statePercent'
}

export enum SecurityType {
  Bond = 'Bond',
  NoType = 'NoType',
  Stock = 'Stock'
}

export type SecurityFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  agents?: InputMaybe<Array<Scalars['String']['input']>>;
  agents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  agents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  agents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  agents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  agents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<InputMaybe<SecurityFilter>>>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<AssetFilter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  authorizationList?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationList_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationList_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationList_not?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationList_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  authorizationList_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  enabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  factory?: InputMaybe<Scalars['String']['input']>;
  factory_?: InputMaybe<SecurityFactoryFilter>;
  factory_contains?: InputMaybe<Scalars['String']['input']>;
  factory_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_ends_with?: InputMaybe<Scalars['String']['input']>;
  factory_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_gt?: InputMaybe<Scalars['String']['input']>;
  factory_gte?: InputMaybe<Scalars['String']['input']>;
  factory_in?: InputMaybe<Array<Scalars['String']['input']>>;
  factory_lt?: InputMaybe<Scalars['String']['input']>;
  factory_lte?: InputMaybe<Scalars['String']['input']>;
  factory_not?: InputMaybe<Scalars['String']['input']>;
  factory_not_contains?: InputMaybe<Scalars['String']['input']>;
  factory_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  factory_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  factory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  factory_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_starts_with?: InputMaybe<Scalars['String']['input']>;
  factory_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  frozen?: InputMaybe<Scalars['Boolean']['input']>;
  frozen_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  frozen_not?: InputMaybe<Scalars['Boolean']['input']>;
  frozen_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  kya?: InputMaybe<Scalars['String']['input']>;
  kya_contains?: InputMaybe<Scalars['String']['input']>;
  kya_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_ends_with?: InputMaybe<Scalars['String']['input']>;
  kya_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_gt?: InputMaybe<Scalars['String']['input']>;
  kya_gte?: InputMaybe<Scalars['String']['input']>;
  kya_in?: InputMaybe<Array<Scalars['String']['input']>>;
  kya_lt?: InputMaybe<Scalars['String']['input']>;
  kya_lte?: InputMaybe<Scalars['String']['input']>;
  kya_not?: InputMaybe<Scalars['String']['input']>;
  kya_not_contains?: InputMaybe<Scalars['String']['input']>;
  kya_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  kya_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  kya_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  kya_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_starts_with?: InputMaybe<Scalars['String']['input']>;
  kya_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lastInterestRate?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastInterestRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  metadata_?: InputMaybe<SecurityMetadataFilter>;
  metadata_contains?: InputMaybe<Scalars['String']['input']>;
  metadata_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  metadata_ends_with?: InputMaybe<Scalars['String']['input']>;
  metadata_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  metadata_gt?: InputMaybe<Scalars['String']['input']>;
  metadata_gte?: InputMaybe<Scalars['String']['input']>;
  metadata_in?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata_lt?: InputMaybe<Scalars['String']['input']>;
  metadata_lte?: InputMaybe<Scalars['String']['input']>;
  metadata_not?: InputMaybe<Scalars['String']['input']>;
  metadata_not_contains?: InputMaybe<Scalars['String']['input']>;
  metadata_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  metadata_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  metadata_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  metadata_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  metadata_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  metadata_starts_with?: InputMaybe<Scalars['String']['input']>;
  metadata_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  minimumRedemptionAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  minimumRedemptionAmount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SecurityFilter>>>;
  statePercent?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  statePercent_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum SecurityOrderBy {
  Agents = 'agents',
  Asset = 'asset',
  AssetAddress = 'asset__address',
  AssetAssetType = 'asset__assetType',
  AssetDecimals = 'asset__decimals',
  AssetId = 'asset__id',
  AssetKya = 'asset__kya',
  AssetName = 'asset__name',
  AssetSymbol = 'asset__symbol',
  AssetTokenId = 'asset__tokenId',
  AssetTokenStandard = 'asset__tokenStandard',
  AssetTradedVolume = 'asset__tradedVolume',
  AuthorizationList = 'authorizationList',
  Enabled = 'enabled',
  Factory = 'factory',
  FactoryId = 'factory__id',
  FactorySecuritiesCount = 'factory__securitiesCount',
  Frozen = 'frozen',
  Id = 'id',
  Kya = 'kya',
  LastInterestRate = 'lastInterestRate',
  Metadata = 'metadata',
  MetadataDescription = 'metadata__description',
  MetadataExternalUrl = 'metadata__externalUrl',
  MetadataId = 'metadata__id',
  MetadataImage = 'metadata__image',
  MetadataSecurityType = 'metadata__securityType',
  MinimumRedemptionAmount = 'minimumRedemptionAmount',
  StatePercent = 'statePercent'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<Meta>;
  asset?: Maybe<Asset>;
  assetPrice?: Maybe<AssetPrice>;
  assetPrices: Array<AssetPrice>;
  assets: Array<Asset>;
  offer?: Maybe<Offer>;
  offerPrice?: Maybe<OfferPrice>;
  offerPrices: Array<OfferPrice>;
  offers: Array<Offer>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  securities: Array<Security>;
  security?: Maybe<Security>;
  securityFactories: Array<SecurityFactory>;
  securityFactory?: Maybe<SecurityFactory>;
  securityMetadata?: Maybe<SecurityMetadata>;
  securityMetadata_collection: Array<SecurityMetadata>;
  sx1155?: Maybe<Sx1155>;
  sx1155S: Array<Sx1155>;
  transaction?: Maybe<Transaction>;
  transactions: Array<Transaction>;
  user?: Maybe<User>;
  users: Array<User>;
};


export type SubscriptionMetaArgs = {
  block?: InputMaybe<BlockHeight>;
};


export type SubscriptionAssetArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionAssetPriceArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionAssetPricesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetPriceOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetPriceFilter>;
};


export type SubscriptionAssetsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetFilter>;
};


export type SubscriptionOfferArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionOfferPriceArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionOfferPricesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfferPriceOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OfferPriceFilter>;
};


export type SubscriptionOffersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfferOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OfferFilter>;
};


export type SubscriptionOrderArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionOrdersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OrderFilter>;
};


export type SubscriptionSecuritiesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SecurityFilter>;
};


export type SubscriptionSecurityArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionSecurityFactoriesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityFactoryOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SecurityFactoryFilter>;
};


export type SubscriptionSecurityFactoryArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionSecurityMetadataArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionSecurityMetadataCollectionArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityMetadataOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SecurityMetadataFilter>;
};


export type SubscriptionSx1155Args = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionSx1155SArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Sx1155OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<Sx1155Filter>;
};


export type SubscriptionTransactionArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionTransactionsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<TransactionFilter>;
};


export type SubscriptionUserArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionUsersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<UserFilter>;
};

export enum TokenStandard {
  Erc20 = 'ERC20',
  Erc721 = 'ERC721',
  Erc1155 = 'ERC1155',
  NoType = 'NoType'
}

export type Transaction = {
  __typename?: 'Transaction';
  asset: Asset;
  block: Scalars['Int']['output'];
  caller: User;
  gasPrice: Scalars['BigDecimal']['output'];
  gasUsed: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  timestamp: Scalars['Int']['output'];
  type: TransactionType;
};

export enum TransactionType {
  AddBatchToBlacklist = 'addBatchToBlacklist',
  AddBatchToGreylist = 'addBatchToGreylist',
  AddBatchToWhitelist = 'addBatchToWhitelist',
  AddToBlacklist = 'addToBlacklist',
  AddToGreylist = 'addToGreylist',
  AddToWhitelist = 'addToWhitelist',
  BurnBatch = 'burnBatch',
  BurnSingle = 'burnSingle',
  Creation = 'creation',
  ForceBurnBatch = 'forceBurnBatch',
  ForceBurnSingle = 'forceBurnSingle',
  ForceTransferBatch = 'forceTransferBatch',
  ForceTransferSingle = 'forceTransferSingle',
  MintBatch = 'mintBatch',
  MintSingle = 'mintSingle',
  NotSet = 'notSet',
  Pause = 'pause',
  RemoveBatchFromBlacklist = 'removeBatchFromBlacklist',
  RemoveBatchFromGreylist = 'removeBatchFromGreylist',
  RemoveBatchFromWhitelist = 'removeBatchFromWhitelist',
  RemoveFromBlacklist = 'removeFromBlacklist',
  RemoveFromGreylist = 'removeFromGreylist',
  RemoveFromWhitelist = 'removeFromWhitelist',
  SetContractUri = 'setContractUri',
  TransferBatch = 'transferBatch',
  TransferRequestApproved = 'transferRequestApproved',
  TransferRequestCancelled = 'transferRequestCancelled',
  TransferRequestCreated = 'transferRequestCreated',
  TransferSingle = 'transferSingle',
  Unpause = 'unpause',
  UpdateGlobalAuth = 'updateGlobalAuth',
  UpdateGlobalKya = 'updateGlobalKYA',
  UpdateTokenIdAuth = 'updateTokenIdAuth',
  UpdateTokenIdKya = 'updateTokenIdKYA'
}

export type TransactionFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<TransactionFilter>>>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<AssetFilter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['Int']['input']>;
  block_gt?: InputMaybe<Scalars['Int']['input']>;
  block_gte?: InputMaybe<Scalars['Int']['input']>;
  block_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  block_lt?: InputMaybe<Scalars['Int']['input']>;
  block_lte?: InputMaybe<Scalars['Int']['input']>;
  block_not?: InputMaybe<Scalars['Int']['input']>;
  block_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  caller?: InputMaybe<Scalars['String']['input']>;
  caller_?: InputMaybe<UserFilter>;
  caller_contains?: InputMaybe<Scalars['String']['input']>;
  caller_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  caller_ends_with?: InputMaybe<Scalars['String']['input']>;
  caller_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  caller_gt?: InputMaybe<Scalars['String']['input']>;
  caller_gte?: InputMaybe<Scalars['String']['input']>;
  caller_in?: InputMaybe<Array<Scalars['String']['input']>>;
  caller_lt?: InputMaybe<Scalars['String']['input']>;
  caller_lte?: InputMaybe<Scalars['String']['input']>;
  caller_not?: InputMaybe<Scalars['String']['input']>;
  caller_not_contains?: InputMaybe<Scalars['String']['input']>;
  caller_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  caller_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  caller_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  caller_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  caller_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  caller_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  caller_starts_with?: InputMaybe<Scalars['String']['input']>;
  caller_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  gasPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  gasPrice_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  gasUsed?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  gasUsed_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<TransactionFilter>>>;
  timestamp?: InputMaybe<Scalars['Int']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Int']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Int']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Int']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Int']['input']>;
  timestamp_not?: InputMaybe<Scalars['Int']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<TransactionType>;
  type_in?: InputMaybe<Array<TransactionType>>;
  type_not?: InputMaybe<TransactionType>;
  type_not_in?: InputMaybe<Array<TransactionType>>;
};

export enum TransactionOrderBy {
  Asset = 'asset',
  AssetAddress = 'asset__address',
  AssetAssetType = 'asset__assetType',
  AssetDecimals = 'asset__decimals',
  AssetId = 'asset__id',
  AssetKya = 'asset__kya',
  AssetName = 'asset__name',
  AssetSymbol = 'asset__symbol',
  AssetTokenId = 'asset__tokenId',
  AssetTokenStandard = 'asset__tokenStandard',
  AssetTradedVolume = 'asset__tradedVolume',
  Block = 'block',
  Caller = 'caller',
  CallerId = 'caller__id',
  GasPrice = 'gasPrice',
  GasUsed = 'gasUsed',
  Id = 'id',
  Timestamp = 'timestamp',
  Type = 'type'
}

export type User = {
  __typename?: 'User';
  /** User address */
  id: Scalars['ID']['output'];
  transactions?: Maybe<Array<Transaction>>;
};


export type UserTransactionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionFilter>;
};

export type UserFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<UserFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<UserFilter>>>;
  transactions_?: InputMaybe<TransactionFilter>;
};

export enum UserOrderBy {
  Id = 'id',
  Transactions = 'transactions'
}

export type Block = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']['output']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type Meta = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: Block;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum SubgraphErrorPolicy {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type LockedAmountsInOtcQueryVariables = Exact<{
  filter?: InputMaybe<OfferFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LockedAmountsInOtcQuery = { __typename?: 'Query', offers: Array<{ __typename?: 'Offer', id: string, availableAmount: string, maker: string, offerStatus: OfferStatus, depositAsset: { __typename?: 'Asset', id: string, name: string, symbol: string, address: string, decimals?: number | null, tokenId?: number | null, assetType: AssetType, kya?: string | null, tokenStandard: TokenStandard, tradedVolume: string } }> };

export type OffersQueryVariables = Exact<{
  filter?: InputMaybe<OfferFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfferOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
}>;


export type OffersQuery = { __typename?: 'Query', offers: Array<{ __typename?: 'Offer', id: string, amountIn: string, amountOut?: string | null, availableAmount: string, maker: string, offerStatus: OfferStatus, offerType: OfferType, specialAddresses?: Array<string> | null, isAuth: boolean, isPrivate: boolean, terms?: string | null, timelockPeriod: string, cancelledAt?: string | null, commsLink?: string | null, createdAt: string, authorizationAddresses?: Array<string> | null, expiryTimestamp: string, offerPrice: { __typename?: 'OfferPrice', id: string, percentage?: number | null, percentageType?: PercentageType | null, pricingType: OfferPricingType, unitPrice?: string | null, depositAssetPrice?: { __typename?: 'AssetPrice', priceFeedAddress?: string | null } | null, withdrawalAssetPrice?: { __typename?: 'AssetPrice', priceFeedAddress?: string | null } | null }, depositAsset: { __typename?: 'Asset', id: string, name: string, symbol: string, address: string, decimals?: number | null, tokenId?: number | null, assetType: AssetType, kya?: string | null, tokenStandard: TokenStandard, tradedVolume: string }, withdrawalAsset: { __typename?: 'Asset', id: string, name: string, symbol: string, address: string, decimals?: number | null, tokenId?: number | null, assetType: AssetType, kya?: string | null, tokenStandard: TokenStandard, tradedVolume: string } }> };

export type TokenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TokenQuery = { __typename?: 'Query', asset?: { __typename?: 'Asset', id: string, name: string, symbol: string, address: string, decimals?: number | null, tokenId?: number | null, assetType: AssetType, kya?: string | null, tokenStandard: TokenStandard, tradedVolume: string } | null };

export type TokensQueryVariables = Exact<{
  filter?: InputMaybe<AssetFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TokensQuery = { __typename?: 'Query', assets: Array<{ __typename?: 'Asset', id: string, name: string, symbol: string, address: string, decimals?: number | null, tokenId?: number | null, assetType: AssetType, kya?: string | null, tokenStandard: TokenStandard, tradedVolume: string }> };


export const LockedAmountsInOtcDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LockedAmountsInOTC"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Offer_filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maker"}},{"kind":"Field","name":{"kind":"Name","value":"offerStatus"}},{"kind":"Field","name":{"kind":"Name","value":"depositAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"tokenId"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"kya"}},{"kind":"Field","name":{"kind":"Name","value":"tokenStandard"}},{"kind":"Field","name":{"kind":"Name","value":"tradedVolume"}}]}}]}}]}}]} as unknown as DocumentNode<LockedAmountsInOtcQuery, LockedAmountsInOtcQueryVariables>;
export const OffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Offers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Offer_filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Offer_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amountIn"}},{"kind":"Field","name":{"kind":"Name","value":"amountOut"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maker"}},{"kind":"Field","name":{"kind":"Name","value":"offerStatus"}},{"kind":"Field","name":{"kind":"Name","value":"offerType"}},{"kind":"Field","name":{"kind":"Name","value":"specialAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"isAuth"}},{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}},{"kind":"Field","name":{"kind":"Name","value":"timelockPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"commsLink"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"authorizationAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"expiryTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"offerPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"percentageType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"depositAssetPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceFeedAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalAssetPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceFeedAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"tokenId"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"kya"}},{"kind":"Field","name":{"kind":"Name","value":"tokenStandard"}},{"kind":"Field","name":{"kind":"Name","value":"tradedVolume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"tokenId"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"kya"}},{"kind":"Field","name":{"kind":"Name","value":"tokenStandard"}},{"kind":"Field","name":{"kind":"Name","value":"tradedVolume"}}]}}]}}]}}]} as unknown as DocumentNode<OffersQuery, OffersQueryVariables>;
export const TokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Token"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"tokenId"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"kya"}},{"kind":"Field","name":{"kind":"Name","value":"tokenStandard"}},{"kind":"Field","name":{"kind":"Name","value":"tradedVolume"}}]}}]}}]} as unknown as DocumentNode<TokenQuery, TokenQueryVariables>;
export const TokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Tokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Asset_filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"tradedVolume"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"desc"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"tokenId"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"kya"}},{"kind":"Field","name":{"kind":"Name","value":"tokenStandard"}},{"kind":"Field","name":{"kind":"Name","value":"tradedVolume"}}]}}]}}]} as unknown as DocumentNode<TokensQuery, TokensQueryVariables>;